import { useNavigate } from 'react-router-dom';
import { ROUTES } from 'shared/constants';
import { SESSION_STORAGE_KEYS } from 'shared/sessionStorageUtils';
import useLocalStorage from './useLocalStorage';

const useRestartCalculator = () => {
  const navigate = useNavigate();
  const { getValueFromLocalStorage, saveValueToLocalStorage } = useLocalStorage();

  const country = getValueFromLocalStorage(SESSION_STORAGE_KEYS.country);
  const selectedLanguage = getValueFromLocalStorage(SESSION_STORAGE_KEYS.language);

  const restartCalculator = () => {
    navigate(ROUTES.structureSelect);
    localStorage.clear();
    saveValueToLocalStorage(SESSION_STORAGE_KEYS.country, country);
    saveValueToLocalStorage(SESSION_STORAGE_KEYS.language, selectedLanguage);
  };

  return restartCalculator;
};

export default useRestartCalculator;
